"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationV1 = void 0;
var LocationV1 = /** @class */ (function () {
    function LocationV1(data) {
        this.possibleTypes = data.possibleTypes;
        this.containmentConstraints = data.containmentConstraints;
        this.possibleTypesForPassages = data.possibleTypesForPassages;
    }
    LocationV1.prototype.getPossibleTypes = function () {
        return this.possibleTypes;
    };
    LocationV1.prototype.getContainmentConstraints = function () {
        return this.containmentConstraints;
    };
    LocationV1.prototype.getPossibleTypesForPassages = function () {
        return this.possibleTypesForPassages;
    };
    return LocationV1;
}());
exports.LocationV1 = LocationV1;
//# sourceMappingURL=location.js.map